import { mapActions, mapMutations, mapGetters } from "vuex";
import gql from "graphql-tag";
import iris from "@/iris";
export default {
  apollo: {
    initialStory: {
      query: gql`
        query GetStory($id: ID!) {
          story(id: $id) {
            id
            name
            summary
            description
            duration
            image {
              id
              contentUrl
            }
            owner {
              email
            }
            ageRating {
              _id
              id
            }
            genre {
              _id
              id
            }
            tags {
              _id
              id
            }
          }
        }
      `,
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      variables() {
        return {
          id: this.id,
        };
      },
      update(data) {
        return data.story;
      },
      result({ data }) {
        this.loading = false;
        if (data != undefined) {
          this.storyFound = true;
          if (
            !this.getMe ||
            (this.getMe && this.getMe.email != data.story.owner.email)
          ) {
            this.$emit("unauthorized");
          } else {
            this.authorized = true;
            this.localEditedStory = { ...data.story };
            this.localEditedStory.description = data.story.description;
            this.setStory(data.story);
            if (data.story.genre) {
              this.genre = data.story.genre.id;
            }
            if (data.story.ageRating) {
              this.ageRating = data.story.ageRating.id;
            }
            if (data.story.tags) {
              let tags = data.story.tags.map((tag) => tag.id);
              this.tags = tags;
            }
          }
        } else {
          this.storyFound = false;
        }
      },
    },
  },
  computed: {
    id() {
      return `${iris.story}${this.$route.params.id}`;
    },
    updateOrLoadInProgress() {
      return this.getInProgress || this.loading;
    },
    ...mapGetters("story", ["getInProgress", "getStory", "getEditedStory"]),
    ...mapGetters("formNavGuard", ["getSaveChanges"]),
    ...mapGetters("auth", ["getMe"]),
    ...mapGetters("sharedStoryDescription", ["getText"]),
  },
  watch: {
    localEditedStory: {
      handler(newValue) {
        if (newValue.name !== undefined) {
          this.setEditedStory(newValue);
          this.setText(newValue.description);
        }
      },
      deep: true,
    },
    getText: function (newValue) {
      if (this.localEditedStory.description != newValue) {
        this.localEditedStory.description = newValue;
      }
    },
    getSaveChanges: function (newValue) {
      if (newValue === true) {
        this.saveStory();
        this.setSaveChanges(false);
      }
    },
  },
  data() {
    return {
      genre: "",
      ageRating: "",
      tags: [],
      loading: true,
      localEditedStory: {},
      description: "",
      storyFound: false,
      authorized: false,
    };
  },
  methods: {
    genreObject(object) {
      this.localEditedStory.genre = object;
    },
    ageRatingObject(object) {
      this.localEditedStory.ageRating = object;
    },
    tagsObject(object) {
      this.localEditedStory.tags = object;
    },
    ...mapActions("story", ["updateStory"]),
    saveStory() {
      if (this.getText) {
        this.localEditedStory.description = this.getText;
      }
      this.updateStory(this.localEditedStory);
    },
    ...mapMutations("story", ["setStory", "setStory", "setEditedStory"]),
    ...mapMutations("sharedStoryDescription", ["setText"]),
    ...mapMutations("formNavGuard", ["setSaveChanges"]),
  },
}